export const fetcher = async (
  url: string,
  opt: { method: string; next: object }
) => {
  const options: object = {
    ...opt,
    headers: {
      'Content-type': 'application/json',
    },
    // next: { revalidate:300 },
  };
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}${url}`,
      options
    );

    if (!response.ok) {
      console.error(`Status: ${response.status}. Api Error: ${url}`);
      return { data: [] };
    }

    const res = await response.json();
    return res;
  } catch (error) {
    console.error(`Fetch error: ${url}`, error);
    return { data: [] };
  }
};
